import type { PermissionItem } from './types'

import { Permission } from '@/types/schema/permissions'

// `TradingPermissions` now lives in `@moment/app-config-ui` so packages can
// consume it directly. Re-exported so existing
// `@/config/permissions/trading-permissions` import sites keep working.
export { TradingPermissions } from '@moment/app-config-ui/permissions'

// Trade desk permissions
export const tradePermissions: PermissionItem[] = [
  {
    id: Permission.AllowListUpdate,
    title: 'Update allow list',
    description: 'A user can modify the allowed securities list',
  },
  {
    id: Permission.OMSOrderReadAll,
    title: 'View all orders and all of their metadata',
    description:
      'A user can view every order in their organization hierarchy as well as all associated metadata.',
  },
  {
    id: Permission.OMSOrderCreate,
    title: 'Create orders',
    description:
      'A user can create orders through the order entry form on the trade desk blotter',
  },
  {
    id: Permission.OMSOrderCancel,
    title: 'Cancel orders',
    description: 'A user can cancel orders in the trade desk blotter',
  },
  {
    id: Permission.OMSTradeCancel,
    title: 'Cancel trades',
    description:
      'A user can request the cancel of a filled execution on an order',
  },
  {
    id: Permission.OMSOrderManualReview,
    title: 'Manual review',
    description:
      'A user can approve or reject orders flagged for manual review',
  },
  {
    id: Permission.OMSExecutionInstructionCreate,
    title: 'Create execution instructions',
    description:
      'A user can set execution instruction for orders in the trade desk blotter',
  },
  {
    id: Permission.OMSExecutionInstructionCancel,
    title: 'Cancel execution instructions',
    description:
      'A user can cancel execution instruction for orders in the trade desk blotter',
  },
  {
    id: Permission.OMSExecutionRulesetRead,
    title: 'Read execution rules',
    description: 'A user can view execution rules',
  },
  {
    id: Permission.OMSExecutionRulesetWrite,
    title: 'Write execution rules',
    description: 'A user can write execution rules',
  },
  {
    id: Permission.OMSExecutionRulesetForOrgWrite,
    title: 'Write execution rules for org',
    description: 'A user can write execution rules for org',
  },
  {
    id: Permission.OMSInquiryPricingRulesetRead,
    title: 'Read inquiry pricing rules',
    description: 'A user can view inquiry pricing rules',
  },
  {
    id: Permission.OMSInquiryPricingRulesetWrite,
    title: 'Write inquiry pricing rules',
    description: 'A user can write inquiry pricing rules',
  },
  {
    id: Permission.RFQRead,
    title: 'Read RFQs',
    description: 'A user can view RFQ responses',
  },
  {
    id: Permission.RFQCreate,
    title: 'Create RFQs',
    description: 'A user can create and send RFQs',
  },
  {
    id: Permission.RFQCancel,
    title: 'Cancel RFQs',
    description: 'A user can cancel RFQs',
  },
  {
    id: Permission.LPLEditCheckRead,
    title: 'Read LPL edit checks',
    description: 'A user can view LPL edit checks',
  },
  {
    id: Permission.LPLEditCheckCreate,
    title: 'Create LPL edit checks',
    description: 'A user can create LPL edit checks',
  },
]
